import React from 'react'

const PublicWifiIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M18.37 18.197a3.29 3.29 0 0 0-4.656 0m6.985-2.334a6.585 6.585 0 0 0-9.314 0m14.797-.511h-.806V25.96a2.667 2.667 0 0 1-2.667 2.667H9.375A2.676 2.676 0 0 1 6.71 25.96V15.352h-.8c-1.789 0-3.49-2.095-2.012-3.487.953-.897 10.137-7.697 10.137-7.697 1.186-.936 2.5-1.211 4.025 0 0 0 1.055.765 2.49 1.82v-.421a2.157 2.157 0 0 1 2.15-2.149h3.285v6.639c1.053.813 1.885 1.483 2.211 1.808 1.267 1.267-.223 3.487-2.013 3.487Zm-10.14 4.963a.207.207 0 1 0 .205.205.205.205 0 0 0-.205-.2v-.005Z"
        stroke="url(#a)"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="a"
          x1={26.134}
          y1={-5.804}
          x2={-0.457}
          y2={9.276}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E60000" />
          <stop offset={1} stopColor="#900" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PublicWifiIcon